/** @jsxImportSource @emotion/react */
import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import { EmailTemplateTypeEnum } from '__generatedTypes__/globalTypes'
import { CommonEmail } from '../CommonEmail'

type Props = {
  platform: Platform
}

export const MembershipExpiration = ({ platform }: Props) => (
  <CommonEmail
    type={EmailTemplateTypeEnum.MembershipExpiration}
    platformId={platform.id}
    withDisableForMember
    withDaysPriorExpiration
  />
)
